import escape from 'lodash/escape';

import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

@Pipe({ name: 'highlightString' })
export class HighlightStringPipe implements PipeTransform {
  constructor(private sanitizer: DomSanitizer) {}

  public transform(value: string, match: string): SafeHtml {
    const escapedValue: string = escape(value);
    const escapedMatch: string = escape(match);

    const matchingRegex: RegExp = new RegExp(this.escapeRegExp(escapedMatch), 'gi');
    const updatedString: string = escapedValue.replace(
      matchingRegex,
      (matchedString: string) => (`<strong>${matchedString}</strong>`),
    );
    const result: string = `<span class="phx-web-color-content-standard">${updatedString}</span>`;

    return this.sanitizer.bypassSecurityTrustHtml(result);
  }

  private escapeRegExp(stringValue: string): string {
    return stringValue.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
  }
}
